<template>
  <div v-if="visible" class="toast" :class="type">
    {{ message }}
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      required: true,
    },
    type: {
      type: String,
      default: 'success', // success, error, warning, info
    },
    duration: {
      type: Number,
      default: 5000,
    },
  },
  data() {
    return {
      visible: false,
    };
  },
  mounted() {
    this.showToast();
  },
  methods: {
    showToast() {
      this.visible = true;
      let me = this
      setTimeout(() => {
        me.visible = false;
        me.$emit('closed')
      }, this.duration);
    },
  },
};
</script>

<style scoped>
.toast {
  position: fixed;
  bottom: 20px;
  left: 15px;
  padding: 10px 20px;
  border-radius: 5px;
  color: #fff;
  font-weight: bold;
  z-index: 10000000;
  opacity: 0.9;
  min-width: 97%
}

.toast.success {
  background-color: #4caf50;
}
.toast.error {
  background-color: #f44336;
}
.toast.warning {
  background-color: #ff9800;
}
.toast.info {
  background-color: #2196f3;
}
</style>
